export class FailedToParseError extends Error {
    constructor(value: any, format: string) {
        super(`Failed to parse ${value.toString()}, format should be ${format}`);
    }
}
